const { Component, render, Fragment } = wp.element;
import Comparison_Tables_View from "./view";

// Instantiate for every carousel on page
document.addEventListener("DOMContentLoaded", function (event) {
    let players = document.querySelectorAll('.Comparison_Tables_frontend-wrapper');

    for (let i = 0; i < players.length; i++) {
      let parentElm = players[i];
      let selectedID = JSON.parse( parentElm.getAttribute('data-selectedid') );

      render(
        <Comparison_Tables_View selectedID={ parseInt(selectedID) } />,
        parentElm
      );
    }
});


// WEBPACK FOOTER //
// ./src/frontend.js